// Teams pricing shared by Manage Subscription and the checkout page.
// Values from the Teams proposal; the backend's Stripe prices are the source
// of truth for what is actually charged.

// Whether ZT Teams is offered to new customers: the ZT Teams tab on Manage
// Subscription and the Teams cards on the pricing pages. false only hides
// the offer; every Teams flow keeps working, and existing teams, members and
// invites are unaffected. Set back to true to show the plan again.
export const TEAMS_PLAN_VISIBLE = false;

export const TEAM_MIN_SEATS = 3;
export const TEAM_MAX_SEATS = 500;
export const TEAM_DEFAULT_SEATS = 8;

// Per seat, per month. Annual is billed yearly: $115.20 per seat (20% off).
export const TEAM_PRICE_PER_SEAT = {
  monthly: 12,
  annual: 9.6,
};

// Dollars rounded to whole cents (9.6 * 12 is 115.19999… in JavaScript).
export const roundCents = (amount) => Math.round(Number(amount || 0) * 100) / 100;

// One seat for one billing period: $12 a month, or $115.20 a year.
export const teamSeatPeriodPrice = (interval, perSeatMonthly = TEAM_PRICE_PER_SEAT[normalizeInterval(interval)]) =>
  roundCents(perSeatMonthly * (normalizeInterval(interval) === "annual" ? 12 : 1));

// Annual's saving against paying monthly for a year, rounded ("20").
export const TEAM_ANNUAL_SAVING_PCT = Math.round((1 - TEAM_PRICE_PER_SEAT.annual / TEAM_PRICE_PER_SEAT.monthly) * 100);

export function normalizeInterval(value) {
  return String(value || "").toLowerCase() === "annual" ? "annual" : "monthly";
}

export const clampSeats = (value) => {
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return TEAM_DEFAULT_SEATS;
  return Math.min(Math.max(n, TEAM_MIN_SEATS), TEAM_MAX_SEATS);
};

// What one billing period costs: a month for monthly, a year for annual.
export const teamPeriodTotal = (seats, interval) => roundCents(teamSeatPeriodPrice(interval) * seats);

export const formatUsd = (amount, { trimZeros = false } = {}) => {
  const fixed = Number(amount || 0).toFixed(2);
  const [whole, cents] = fixed.split(".");
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return trimZeros && cents === "00" ? withCommas : `${withCommas}.${cents}`;
};

// Plan keys the backend understands (POST /api/org/create-subscription-session).
export const teamPlanKey = (interval) => (normalizeInterval(interval) === "annual" ? "Teams_Annual" : "Teams_Monthly");

export const isTeamPlanKey = (plan) => plan === "Teams_Monthly" || plan === "Teams_Annual";

export const intervalOfPlanKey = (plan) => (plan === "Teams_Annual" ? "annual" : "monthly");
